<template>
  <div style="width: 100%" v-loading="loading">
    <addFolder @addAppend="addAppend" :cheked="this.cheked" />

    <!-- 		<el-button 
			@click="editDocument(false, null)"
			:disabled="!cheked"
			>
			<i class="el-icon-edit m-r-20"></i>Редактировать
		</el-button> -->

    <editItem
      :cheked="this.cheked"
      @editDocument="editDocument"
      ref="editItem"
    />

    <addDocuments
      :catalogId="this.cheked"
      v-on:addFile="addFile"
      v-on:loadList="loadList"
    />

    <h1>Документы</h1>
    <el-tree
      :data="getDocumentsList"
      node-key="id"
      show-checkbox
      check-strictly
      highlight-current
      empty-text="Список пуст"
      @node-drop="handleDrop"
      :props="defaultProps"
      ref="tree"
      :default-expanded-keys="expandedKeys"
      @node-drag-end="handleDragEnd"
      draggable
      :allow-drop="allowDrop"
      :allow-drag="allowDrag"
      @check-change="handleCheckChange"
      :expand-on-click-node="false"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span :class="data.isFolder ? 'tree-folder' : ''">
          <i class="fas fa-folder folder" v-if="data.isFolder"></i>
          <i class="fas fa-file-pdf pdf" v-else-if="data.file == '.pdf'"></i>
          <i class="fas fa-file-alt alt" v-else-if="data.file == '.txt'"></i>
          <i
            class="fas fa-file-excel excel"
            v-else-if="data.file == '.xls'"
          ></i>
          <i
            class="fas fa-file-excel excel"
            v-else-if="data.file == '.xlsx'"
          ></i>
          <i class="fas fa-file-word word" v-else-if="data.file == '.docx'"></i>
          <i
            class="fas fa-file-archive archive"
            v-else-if="data.file == '.zip'"
          ></i>
          <i
            class="fas fa-file-archive archive-rar"
            v-else-if="data.file == '.rar'"
          ></i>
          <i
            class="fas fa-file-image image"
            v-else-if="data.file == '.png'"
          ></i>
          <i
            class="fas fa-file-image image"
            v-else-if="data.file == '.jpeg'"
          ></i>
          <i
            class="fas fa-file-image image"
            v-else-if="data.file == '.bmp'"
          ></i>
          <i
            class="fas fa-file-invoice image"
            v-else-if="data.file == '.odt'"
          ></i>
          <i
            class="fas fa-file-image image"
            v-else-if="data.file == '.jpg'"
          ></i>
          <i class="fas fa-file file" v-else></i>

          <span v-if="data.isFolder" class="m-l-10 m-r-20">{{
            node.label
          }}</span>
          <el-tooltip v-else :content="node.label" placement="top">
            <span
              class="m-l-10 m-r-20"
              style="overflow: hidden;max-width: 715px;display: inline-block;"
              >{{ node.label }}</span
            >
          </el-tooltip>
          <i
            v-if="!data.children"
            class="el-icon-delete hover-icon"
            @click="() => removeItem(node, data)"
          ></i>
          <a v-if="!data.isFolder" :href="url + data.fileName"
            ><i
              style="margin-left: 20px;"
              class="el-icon-download hover-icon"
            ></i
          ></a>
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import { BASE_URL, BASE_DOC_URL } from "@/plugins/url-env";
import addDocuments from "./modal/add-documents";
import addFolder from "./modal/add-folder";
import editItem from "./modal/edit-checked-item";

import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      loading: false,
      defaultProps: {
        children: "children",
        id: 1,
        label: "label"
      },
      url: BASE_URL + "/document/",
      cheked: null,
      isFile: false,
      newParent: null,
      expandedKeys: []
    };
  },
  mounted() {
    this.loadList();
  },
  computed: {
    ...mapGetters(["getDocumentsList"])
  },
  methods: {
    ...mapMutations(["addRootCatalog"]),
    async loadList() {
      this.loading = true;
      try {
        await this.$store.dispatch("documentGet");
      } catch (e) {
        this.$ErrorsMod(e);
      }
      this.loading = false;
    },

    handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        this.cheked = data;
        this.isFile = !data.isFolder;
        this.$refs.tree.setCheckedNodes([data]);
      } else if (data.id == this.cheked.id) {
        this.cheked = null;
        this.isFile = false;
      }
    },

    editDocument(value) {
      this.editItem(
        this.cheked.id,
        this.cheked.parentId,
        value,
        this.cheked.isFolder,
        this.cheked.sorting
      );
    },

    async editItem(
      id = null,
      parent = null,
      value,
      isFile = false,
      sorting = null
    ) {
      const DATA = () => {
        if (id == parent || parent == null) {
          return {
            id: id,
            parentId: null,
            title: value,
            sorting: sorting
          };
        } else {
          return {
            id: id,
            parentId: parent,
            title: value,
            sorting: sorting
          };
        }
      };

      try {
        if (!isFile) {
          await this.$store.dispatch("documentEditFile", DATA());
        } else {
          await this.$store.dispatch("documentEditCatalog", DATA());
        }
        this.expandedKeys = [];
        this.expandedKeys.push(id);
        this.loadList();
        this.$refs.editItem.closeDialog();
      } catch (e) {
        this.$ErrorsMod(e);
      }
    },

    removeItem(node, data) {
      this.$confirm(
        `Вы действительно хотите удалить ${data.label} ?`,
        "Подтвердите действие",
        {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        }
      )
        .then(async () => {
          if (data.isFolder) {
            try {
              await this.$store.dispatch("documentDeleteCatalog", {
                id: data.id
              });
              this.cheked = null;
              this.deleteItem(node, data);
            } catch (e) {
              this.$ErrorsMod(e);
            }
          } else {
            try {
              await this.$store.dispatch("documentDeleteFile", {
                id: data.fileName
              });
              this.deleteItem(node, data);
              // this.loadList()
            } catch (e) {
              this.$ErrorsMod(e);
              this.loadList();
            }
          }
        })
        .catch(() => {});
    },

    addFile(data) {
      if (this.cheked == null) {
        this.addRootCatalog({
          id: data.file.response.id,
          label: data.label,
          children: null,
          isFolder: false,
          file: data.extension.toLowerCase(),
          sorting: data.sorting,
          fileName: data.fileName
        });
      } else {
        const newChild = {
          id: data.file.response.id,
          label: data.label,
          children: null,
          isFolder: false,
          file: data.extension.toLowerCase(),
          sorting: data.sorting,
          fileName: data.fileName
        };

        if (this.cheked.children === null) {
          this.cheked.children = [];
        }
        this.cheked.children.push(newChild);
      }
    },

    async addAppend(query) {
      const newChild = {
        id: query.id,
        label: query.title,
        children: [],
        isFolder: true,
        sorting: query.sorting
      };
      this.expandedKeys.push(query.id);

      if (this.cheked == null) {
        this.addRootCatalog(newChild);
      } else if (Array.isArray(this.cheked.children)) {
        this.cheked.children.unshift(newChild);
      } else {
        this.cheked.children = [];
        this.cheked.children.unshift(newChild);
      }
      this.loadList();
    },

    deleteItem(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      this.cheked = null;
      children.splice(index, 1);
    },

    handleDrop(draggingNode, dropNode, dropType, ev) {
      //console.log('tree drop: ', draggingNode, '****', dropNode, dropType, dropNode.data)
      if (dropType == "before") {
        if ((this.newParent = null)) {
          this.newParent = null;
        } else {
          this.newParent = dropNode.data.parentId;
        }
      } else if (dropType == "inner" || dropType == "after") {
        if (dropNode.data.isFolder) {
          this.newParent = dropNode.data.id;
        } else {
          if (dropNode.data.parentId == null) {
            dropNode.data.parentId == null;
          } else {
            this.newParent = dropNode.data.parentId;
          }
        }
      }
    },

    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      if (dropNode) this.dragSort(draggingNode, dropNode, dropType);
    },

    async dragSort(draggingNode = {}, dropNode = {}, dropType = null) {
      //draggingNode что перетаскиваю {}
      //dropNode куда перетаскиваю
      //dropType тип перетаскивания

      /* 				console.log('dropType тип перетаскивания', dropType);
				console.log('dropNode куда перетаскиваю', dropNode);
				console.log('draggingNode что перетаскиваю', draggingNode); */
      let dropNodeTemp = [];
      let idTemp = null;
      let formData = {};

      if (dropType !== "inner") {
        dropNodeTemp = [];
        idTemp = null;
        for (let item of dropNode.parent.childNodes) {
          dropNodeTemp.push({
            id: item.data.id
          });
        }

        //меняем сортировку
        for (let i = 0; i < dropNodeTemp.length; i++) {
          dropNodeTemp[i].sorting = i;
        }

        idTemp = dropNode.parent.data.id || null;

        formData = {
          id: idTemp,
          data: dropNodeTemp
        };
      } else if (dropType == "inner") {
        dropNodeTemp = [];
        idTemp = null;
        for (let item of dropNode.childNodes) {
          dropNodeTemp.push({
            id: item.data.id
          });
        }

        //меняем сортировку
        for (let i = 0; i < dropNodeTemp.length; i++) {
          dropNodeTemp[i].sorting = i;
        }

        idTemp = dropNode.data.id || null;

        formData = {
          id: idTemp,
          data: dropNodeTemp
        };
      }

      await this.$store.dispatch("documentSort", formData);
    },

    allowDrop(draggingNode, dropNode, type) {
      if (!dropNode.data.isFolder) {
        return type !== "inner";
      } else {
        return true;
      }
    },

    allowDrag(draggingNode) {
      return draggingNode.data.label.indexOf("Level three 3-1-1") === -1;
    }
  },

  components: {
    addDocuments,
    addFolder,
    editItem
  }
};
</script>

<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  padding-right: 8px;
}
.el-tree-node__content {
  height: 55px !important;
}

.folder {
  font-size: 20px;
  color: #ffbd5b;
}

.pdf {
  font-size: 20px;
  color: rgb(255, 97, 91);
}

.alt {
  font-size: 20px;
  color: #6baafd;
}
.word {
  font-size: 20px;
  color: #2a5495;
}

.excel {
  font-size: 20px;
  color: rgb(62, 172, 12);
}
.archive {
  font-size: 20px;
  color: #8dd21a;
}
.archive-rar {
  font-size: 20px;
  color: #b65bab;
}

.image {
  font-size: 20px;
  color: #313131;
}

.file {
  font-size: 20px;
  color: #ccc;
}

.tree-folder {
  background: #eaeaea;
  width: 100%;
  line-height: 40px;
  padding-left: 10px;
  border-radius: 3px;
}
.hover-icon:hover {
  border: 1px solid #ccc;
  background: #f3f3f3;
  border-radius: 15px;
  padding: 5px;
  box-sizing: border-box;
}
.hover-icon {
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0);
  padding: 5px;
}

.el-tree-node.is-drop-inner > .el-tree-node__content .tree-folder {
  background: #4c9311;
  color: #fff;
}
</style>
